import { Translation } from "@/data/lang";
import { links } from "@/data/links";
import { Lang } from "@/i18n-config";

export type NavigationLink = {
  name: string;
  anchor?: string;
  pageLink: string;
};

export const getOverviewLinks = (): NavigationLink[] => [];

export const getAiViewLinks = ({
  t,
  symbol,
  lang,
}: {
  t: Translation;
  symbol: string;
  lang: Lang;
}): NavigationLink[] => {
  return [
    {
      name: t.analysis.shared.oriented.value,
      pageLink: `/${lang}${links.myAnalysisValue({ symbol })}`,
    },
    {
      name: t.analysis.shared.oriented.trend,
      pageLink: `/${lang}${links.myAnalysisTrend({ symbol })}`,
    },
    {
      name: t.analysis.shared.oriented.swing,
      pageLink: `/${lang}${links.myAnalysisSwingTrading({ symbol })}`,
    },
    {
      name: t.analysis.shared.oriented.chip,
      pageLink: `/${lang}${links.myAnalysisWhaleInterest({
        symbol,
      })}`,
    },
    {
      name: t.analysis.shared.oriented.dividend,
      pageLink: `/${lang}${links.myAnalysisDividend({ symbol })}`,
    },
  ];
};

export const getTrendLinks = (): NavigationLink[] => [];

export const getSwingTradingLinks = (): NavigationLink[] => [];

export const getGeneralWhaleInterestLinks = (): NavigationLink[] => [];

export const getUSWhaleInterestLinks = (): NavigationLink[] => [];

export const getTWWhaleInterestLinks = (): NavigationLink[] => [];

export const getDividendLinks = (): NavigationLink[] => [];
